import { Typography } from '@mui/material'
import { FC } from 'react'

interface SectionLabelProps {
    text: string;
}

export const SectionLabel: FC<SectionLabelProps> = ({ text }) => {
  return (
    <Typography className="font-semibold text-slate-700">{text}</Typography>
  )
}
